import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

export const headerVisibleState = atom({
  key: 'headerVisibleState',
  default: selector({
    key: 'headerVisibleStateSelector',
    get: () => {
      return getCustomerSettings('header');
    }
  })
});